import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const CampusAll = (props) => {
    const width = props.width ? props.width + 'px' : '297px';
    const height = props.height ? props.height + 'px' : '79px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 297 79"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                d="M140.971 51.4102L133.344 69.2657H138.443L142.948 58.7348L147.447 69.2657H152.546L144.919 51.4102H140.971Z"
                fill="#13120D"
            />
            <path
                d="M143.115 29.2988C137.813 29.2988 133.496 33.6125 133.496 38.9106C133.496 44.2086 137.806 48.5223 143.115 48.5223C148.425 48.5223 152.734 44.2086 152.734 38.9106C152.734 33.6125 148.417 29.2988 143.115 29.2988ZM143.115 43.8322C140.399 43.8322 138.19 41.6247 138.19 38.9106C138.19 36.1964 140.399 33.9889 143.115 33.9889C145.832 33.9889 148.048 36.1964 148.048 38.9106C148.048 41.6247 145.839 43.8322 143.115 43.8322Z"
                fill="#13120D"
            />
            <path
                d="M118.711 29.2988C113.409 29.2988 109.092 33.6125 109.092 38.9106C109.092 44.2086 113.402 48.5223 118.711 48.5223C124.02 48.5223 128.33 44.2086 128.33 38.9106C128.33 33.6125 124.013 29.2988 118.711 29.2988ZM118.711 43.8322C115.995 43.8322 113.785 41.6247 113.785 38.9106C113.785 36.1964 115.995 33.9889 118.711 33.9889C121.427 33.9889 123.644 36.1964 123.644 38.9106C123.644 41.6247 121.435 43.8322 118.711 43.8322Z"
                fill="#13120D"
            />
            <path
                d="M129.917 50.918H107.514V55.6008H112.048V69.2657H116.734V55.6008H120.697V69.2657H125.39V55.6008H129.917V50.918Z"
                fill="#13120D"
            />
            <path d="M297 73.8398H0V79.0004H297V73.8398Z" fill="black" />
            <path
                d="M35.2386 57.2293V68.8315H40.9899V57.2293C50.4425 55.8325 57.7148 47.6828 57.7148 37.8539C57.7148 27.0552 48.9213 18.2686 38.1142 18.2686C27.3071 18.2686 18.5137 27.0552 18.5137 37.8539C18.5137 47.6755 25.7933 55.8325 35.2386 57.2293ZM38.1142 24.0153C45.756 24.0153 51.9636 30.2253 51.9636 37.8539C51.9636 45.4825 45.7488 51.6925 38.1142 51.6925C30.4797 51.6925 24.2649 45.4825 24.2649 37.8539C24.2649 30.2253 30.4797 24.0153 38.1142 24.0153Z"
                fill="black"
            />
            <path
                d="M69.4499 62.2884V68.8241H75.2012V62.2884C81.2928 60.9639 85.8707 55.5428 85.8707 49.0723C85.8707 41.6102 79.7935 35.5449 72.3328 35.5449C64.8721 35.5449 58.7949 41.6174 58.7949 49.0723C58.7949 55.5501 63.3727 60.9711 69.4644 62.2884H69.4499ZM72.3255 41.2845C76.6209 41.2845 80.1194 44.7803 80.1194 49.0723C80.1194 53.3643 76.6209 56.8601 72.3255 56.8601C68.0302 56.8601 64.5317 53.3643 64.5317 49.0723C64.5317 44.7803 68.0302 41.2845 72.3255 41.2845Z"
                fill="black"
            />
            <path
                d="M262.696 62.2884V68.8241H268.447V62.2884C274.539 60.9639 279.117 55.5428 279.117 49.0723C279.117 41.6102 273.04 35.5449 265.579 35.5449C258.118 35.5449 252.041 41.6174 252.041 49.0723C252.041 55.5501 256.619 60.9711 262.711 62.2884H262.696ZM265.572 41.2845C269.867 41.2845 273.366 44.7803 273.366 49.0723C273.366 53.3643 269.867 56.8601 265.572 56.8601C261.276 56.8601 257.778 53.3643 257.778 49.0723C257.778 44.7803 261.276 41.2845 265.572 41.2845Z"
                fill="black"
            />
            <path d="M113.793 0H92.8087V0.0217132H91.418V69.5837H96.329V4.90719H113.793V0Z" fill="black" />
            <path d="M120.378 9.92285H105.754V14.83H120.378V9.92285Z" fill="black" />
            <path d="M198.36 32.9971H193.615V37.7378H198.36V32.9971Z" fill="#13120D" />
            <path d="M188.944 32.9971H184.199V37.7378H188.944V32.9971Z" fill="#13120D" />
            <path d="M179.528 32.9971H174.783V37.7378H179.528V32.9971Z" fill="#13120D" />
            <path d="M198.36 41.6826H193.615V46.4233H198.36V41.6826Z" fill="#13120D" />
            <path d="M188.944 41.6826H184.199V46.4233H188.944V41.6826Z" fill="#13120D" />
            <path d="M179.528 41.6826H174.783V46.4233H179.528V41.6826Z" fill="#13120D" />
            <path d="M198.36 50.3672H193.615V55.1079H198.36V50.3672Z" fill="#13120D" />
            <path d="M188.944 50.3672H184.199V55.1079H188.944V50.3672Z" fill="#13120D" />
            <path d="M179.528 50.3672H174.783V55.1079H179.528V50.3672Z" fill="#13120D" />
            <path d="M235.742 50.3672H230.998V55.1079H235.742V50.3672Z" fill="#13120D" />
            <path d="M226.326 50.3672H221.582V55.1079H226.326V50.3672Z" fill="#13120D" />
            <path d="M216.91 50.3672H212.166V55.1079H216.91V50.3672Z" fill="#13120D" />
            <path
                d="M207.609 68.8964H245.079V65.8131H245.05V42.7609H245.079V41.2844H207.58V28.7124H207.609V23.9717H195.461H178.403H165.365V68.9036H207.609V68.8964ZM240.305 46.4304V64.1484H207.58V46.4304H240.305ZM193.607 64.1484V58.4595H179.519V64.1484H170.102V28.7124H202.828V64.1556H193.607V64.1484Z"
                fill="#13120D"
            />
        </SvgStyled>
    );
};

export default CampusAll;
